import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=95b74e30&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"
import style0 from "./Messages.vue?vue&type=style&index=0&id=95b74e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b74e30",
  null
  
)

export default component.exports